<template>
    <div>
        <q-carousel v-model="carouselInfo.active" :autoplay="list.length > 1 ? carouselInfo.nextTime : 0"
            :infinite="list.length > 1" :navigation="list.length > 1" swipeable animated position="bottom"
            :height="list.length == 1 ? '150px' : '168px'" class=" text-white shadow-1 !bg-[#06080D] mb-[12px]">
            <template v-slot:navigation-icon="{ active, index, onClick }">
                <q-btn size="0px" class="w-[54px] p-0 mr-[8px] btn-active" v-if="active" @click="onClick"
                    :ripple="true">
                    <div class="caruse-progress rounded-[3px] caruse-progress-active relatiive"
                        :class="list.length == 1 ? 'active' : ''">
                    </div>
                </q-btn>

                <q-btn size="0px" class="w-[12px] h-[6px] rounded-[3px] p-0 mr-[8px]" v-else @click="onClick"
                    :ripple="true">
                    <div class="caruse-progress rounded-[3px] relative"
                        :class="index < carouselInfo.active ? '!bg-[#2283F6]' : ''">
                    </div>
                </q-btn>
            </template>

            <q-carousel-slide v-for="(item, index) in list" :key="index" :name="index">
                <div @click="slideClick(item)" class="h-[150px]">
                   
                    <q-img  :src="item.titleUrl"  :fit="'cover'" loading="lazy" spinner-color="white" height="150px"
                        style="width:100%;border-radius: 12px;">
                        <template #loading>
                            <SkeletonLoader  type="flow" height="120px"></SkeletonLoader>
                        </template>
                        <template v-slot:error>
                            <q-img src="@/assets/imgs/error.png" style="width: 100%;height: 100%;"
                                :fit="'cover'"></q-img>
                        </template>
                    </q-img>
                </div>
            </q-carousel-slide>
        </q-carousel>
    </div>

</template>

<script setup lang="ts">
const router = useRouter();
const props = defineProps({
    list: {
        type: Array,
        default: () => []
    }
})
const carouselInfo = reactive({
    active: 0,//当前激活的轮播
    nextTime: 5000,//轮播下一张的时间,单位 ms 
});
//css时间
const cssNextTime = carouselInfo.nextTime + "ms";

const slideClick = (item) => {
    if (item.link) {
        router.push({
            path: item.link,
        })
    }
}

</script>

<style lang="scss" scoped>
:deep(.q-carousel__control) {
    width: 100%;
    height: 18px;
    left: 0px;
    bottom: 0px;

    .q-carousel__navigation-inner {
        align-items: flex-end;
    }

    .q-btn-item {
        padding: 0px;
        margin-top: 0px;
        margin-bottom: 0px;
    }
}

:deep(.q-carousel__slide) {
    padding: 0px;
}

:deep(.q-carousel__navigation-inner) {
    width: 100%;
}

.caruse-progress {
    width: 100%;
    height: 6px;
    background: #2A3546;
}

.caruse-progress-active::after {
    content: '';
    width: 0;
    height: 6px;
    background-color: #2283F6;
    border-radius: 3px;
    position: absolute;
    left: 0;
    top: 0px;
    animation: v-bind('cssNextTime') linear caruse-progress;
}

.active {
    background-color: #2283F6;
}

@keyframes caruse-progress {
    from {
        width: 0;
    }

    to {
        width: 100%;
    }
}
</style>